<template>
  <app-collapse>
    <app-collapse-item
      :is-visible="true"
      :title="label"
    >
      <textarea
        id="SunEditorTextArea"
        ref="editorTextarea"
        style="min-height: 600px; width: 100%"
      />
    </app-collapse-item>
  </app-collapse>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import plugins from 'suneditor/src/plugins'
import suneditor from 'suneditor'

export default {
  name: 'SunEditorBasic',
  components: {
    AppCollapseItem,
    AppCollapse,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    id: {
      type: [String, Number],
      default: '',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: '',
    },
    preserveUnchangedHtml: {
      type: Boolean,
      default: false,
    },
    value: null, // any value type
  },
  data() {
    return {
      selfValue: null,
      sunEditor: null,
      currentValue: null,
      originalHtml: null,
      normalizedInitialHtml: null,
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (this.preserveUnchangedHtml && newVal !== oldVal && newVal !== this.currentValue) {
        this.setValue(newVal)
      } else if (!this.preserveUnchangedHtml && oldVal == null && newVal != null && oldVal !== newVal) {
        this.setValue(newVal)
      }
    },
  },
  mounted() {
    this.sunEditor = suneditor.create(this.preserveUnchangedHtml ? this.$refs.editorTextarea : 'SunEditorTextArea', {
      plugins,
      ...(this.preserveUnchangedHtml ? { width: '100%' } : {}),
      height: 350,
      buttonList: [
        ['undo', 'redo'],
        ['font', 'fontSize', 'formatBlock'],
        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'dir', 'dir_rtl'],
        ['removeFormat'],
        ['fontColor', 'hiliteColor'],
        // ['indent','outdent'],
        ['align', 'horizontalRule', 'list', 'table'],
        ['link', 'image', 'video'],
        '/',
        ['fullScreen', 'showBlocks', 'codeView'],
        ['preview', 'print'],
        // (min-width: 992)
        ['%992', [
          ['undo', 'redo'],
          ['font', 'fontSize', 'formatBlock'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'dir', 'dir_rtl'],
          ['removeFormat'],
          ['fontColor', 'hiliteColor'],
          // ['indent','outdent'],
          '/',
          ['align', 'horizontalRule', 'list', 'table'],
          ['link', 'image', 'video'],
          ['fullScreen', 'showBlocks', 'codeView'],
          ['preview', 'print'],
        ]],
        // (min-width: 767)
        ['%767', [
          ['undo', 'redo'],
          ['font', 'fontSize', 'formatBlock'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'dir', 'dir_rtl'],
          ['removeFormat'],
          '/',
          ['fontColor', 'hiliteColor'],
          // ['indent','outdent'],
          ['align', 'horizontalRule', 'list', 'table'],
          ['link', 'image', 'video'],
          ['fullScreen', 'showBlocks', 'codeView'],
          ['preview', 'print'],
        ]],
        // (min-width: 480)
        ['%480', [
          ['undo', 'redo'],
          ['font', 'fontSize', 'formatBlock'],
          ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript', 'dir', 'dir_rtl'],
          ['removeFormat'],
          '/',
          ['fontColor', 'hiliteColor'],
          // ['indent','outdent'],
          ['align', 'horizontalRule', 'list', 'table'],
          ['link', 'image', 'video'],
          '/',
          ['fullScreen', 'showBlocks', 'codeView'],
          ['preview', 'print'],
        ]],
      ],
    })
    if (this.preserveUnchangedHtml) this.setValue(this.value)
    // this.sunEditor.onChange = (contents) => {
    //   this.setValue(contents)
    //   this.currentValue = contents
    // }
  },
  beforeDestroy() {
    if (this.preserveUnchangedHtml && this.sunEditor) this.sunEditor.destroy()
  },
  methods: {
    sendValToForm() {
      const html = this.sunEditor.getContents()
      this.currentValue = this.preserveUnchangedHtml && html === this.normalizedInitialHtml ? this.originalHtml : html
      this.$emit('input', this.currentValue)
    },
    setValue(val) {
      if (!this.sunEditor) return
      this.sunEditor.setContents(val == null ? '' : val)
      if (this.preserveUnchangedHtml) {
        this.originalHtml = val == null ? '' : val
        this.normalizedInitialHtml = this.sunEditor.getContents()
      }
    },
  },
}
</script>

<style>
@import "~suneditor/dist/css/suneditor.min.css";
</style>
